import styled from '@emotion/styled';

export const InputContainer = styled.label`
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 56px;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(4)};
  border: 1px solid ${({ theme }) => theme.palette.colors.gray[400]};
  cursor: text;
  &:hover,
  &:focus-within {
    border-color: ${({ theme }) => theme.palette.colors.primary};
  }
`;
